
export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    fontSize: '14px',  // Font size for the control
    fontFamily: 'aeonik_medium',  // Custom font family
    border: state.isFocused ? '1px solid #7F56D9' : '2px solid transparent',  // Border only on focus
    borderRadius: '8px', // Rounded corners for the control
    transition: 'border-color 0.3s ease, background-color 0.3s ease', // Smooth transition on hover/focus
    boxShadow:  'none', // Focus effect for better accessibility
    width: '100%', // Full width
    height: '25px', // Control height
    '&:hover': {
      borderColor: '#7F56D9', // Border color on hover
      zIndex:99
    },
  }),


  input: (provided) => ({
    ...provided,
    fontSize: '14px',  // Same font size as control
    width: '100%', // Ensure input takes up full width of the control
    display:"flex",
    alignItems:"center",
    popsition:"absolute",
    height: '25px',

    '&::placeholder': {
      textAlign: 'center', // Center the placeholder text
      color: '#7F56D9', // Placeholder color
      transition: 'text-align 0.3s ease', // Smooth transition for placeholder alignment
    },
    '&:focus': {
      outline: 'none', // Remove outline on focus
      boxShadow: 'none', // Remove default focus box shadow
    },
  }),


  indicatorsContainer: (provided) => ({
    ...provided,
    height: '100%',
    display:"flex",
    alignItems:"center",
    zIndex:99
  }),

  indicatorSeparator: () => ({
    display: 'none', // Remove indicator separator
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '4px',
    color: '#7F56D9', // Color for the dropdown indicator
    transition: 'color 0.3s ease', // Smooth transition for hover effect
    pointerEvents: 'auto', // Allow interaction with the dropdown indicator
  }),

  menuList: (provided) => ({
    ...provided,
    border: '1px solid #7F56D9', // Border for the menu list
    borderRadius: '8px',
    padding: '10px', // Padding inside the menu list
    backgroundColor: '#FFF', // White background for the dropdown menu
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow for visibility
    maxHeight: '300px', // Ensure the menu list doesn't grow too large
    overflowY: 'auto', // Scrollbar for overflowing content
    zIndex:99
  }),

  menu: (provided) => ({
    ...provided,
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Box shadow for dropdown menu
    zIndex:99
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#7F56D9' : state.isFocused ? '#E1D5FE' : 'white', // Light primary color on hover/focus
    color: state.isSelected ? 'white' : 'black', // Text color for selected item
    cursor: 'pointer',
    margin: '4px 0px', // Spacing between options
    borderRadius: '8px', // Rounded corners for options
    transition: 'background-color 0.3s ease', // Smooth transition for hover and select
    '&:hover': {
      backgroundColor: '#E1D5FE', 
    },
    zIndex:99
  }),

  inputContainer: (provided) => ({
    ...provided,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    paddingBottom: '8px',  // Space below the input
  }),

};
